import {last} from 'lodash'

/**
 * Get file name form any file path
 * @param path any path
 */
export default function getFileName(path: string): string  {
  const match = path.match(/\/?([a-z]|[A-Z]|[0-9]|-|_)+\.[a-z]+$/)
  if(!match || match.length < 1) {
    return path
  }
  return last(match[0].split('.')[0].split('/')) || ''
}
